/**
 * Lockstep Software Development Kit for JavaScript / TypeScript
 *
 * (c) 2021-2022 Lockstep, Inc.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author     Lockstep Network <support@lockstep.io>
 * @copyright  2021-2022 Lockstep, Inc.
 * @link       https://github.com/Lockstep-Network/lockstep-sdk-typescript
 */
/**
 * Represents a response to an API call.  The status value contains the HTTP status code returned from the request.
 * If successful, value will be non-null.  If failed,
 */
export class LockstepResponse {
    /**
     * Constructs an API response based on this specified status code
     * @param status The HTTP status code for this response.
     * @param data The contents of the HTTP response.
     */
    constructor(status, data) {
        this.success = status >= 200 && status < 300;
        this.status = status;
        if (this.success) {
            this.value = data;
            this.error = null;
        }
        else {
            this.error = data;
            this.value = null;
        }
    }
}
//# sourceMappingURL=LockstepResponse.js.map